export default "/assets/images/column-image9.c5c6457146bc677c.webp";